<div class="listing-map {{noMargin ? '' : !mapIsInThePopup ? 'mb-5 mt-4' : 'mt-3 popup'}}">
    <div id='map' class="{{!mapIsInThePopup ? '' : 'popup'}}" scrolling='no'></div>
</div>